import { useEffect, useCallback, useState, useRef } from "react"
import { staticClasses } from "@/constants"
import { removeAndCleanLinkConcat, getAnalyticLinkUrl } from "@/utils/helper"
import DOMPurify from "isomorphic-dompurify"

const HeaderNavTabsLoader = props => {
  const { data, columnClassNames, eventHandler } = props

  const selectedTab = "Bathroom"

  const dataRecursion = useCallback(data => {
    if (data && data[":itemsOrder"]) {
      data[":itemsOrder"].map((key, index) => {
        const item = data[":items"][key]
        return dataRecursion(item)
      })
    }
  }, [])

  useEffect(() => {
    dataRecursion(data)
  }, [data, dataRecursion])

  return (
    <div
      className={`tabs ${
        data?.appliedCssClassNames ? data?.appliedCssClassNames : ""
      } ${columnClassNames ? columnClassNames : ""}`}
    >
      <div className="cmp-tabs">
        <span
          className="gbh-hamber-menu gbh-close icon-Close-Medium"
          aria-label="close button"
          tabIndex="0"
        >
          <span></span>
          <span></span>
          <span></span>
        </span>
        <ol
          role="tablist"
          className="cmp-tabs__tablist"
          aria-multiselectable="false"
        >
          {data[":itemsOrder"] &&
            data[":itemsOrder"].map((key, index) => {
              const item = data[":items"][key]
              return (
                <li
                  role="tab"
                  className={`cmp-tabs__tab `}
                  tabIndex="0"
                  key={`navItem-${index}`}
                >
                  {/* {onClickNav(item)} */}
                  {item["cq:panelTitle"]}
                </li>
              )
            })}
          {data?.mainTabId &&
            Object.keys(data?.mainTabId).map((key, index) => {
              return (
                <li
                  role="tab"
                  className="cmp-tabs__tab"
                  tabIndex="0"
                  key={`navItem-${index}`}
                >
                  {key}
                </li>
              )
            })}
        </ol>

        {data[":itemsOrder"] &&
          data[":itemsOrder"].map((key, index) => {
            const items = data[":items"][key]
            const item =
              items[":items"]?.globalnavigation ||
              items[":items"]?.globalnavigation_cop
            const { categoryItems } = item
            if (item?.mainNavigation === "drawer") {
              return (
                <div
                  key={`navTabs-${index}`}
                  role="tabpanel"
                  tabIndex="-1"
                  className={`cmp-tabs__tabpanel`}
                >
                  <div className={`${staticClasses.CONTAINER}`}>
                    <div className="cmp-container">
                      <div className="aem-Grid aem-Grid--11 aem-Grid--default--11 ">
                        <div className="globalnavigation aem-GridColumn aem-GridColumn--default--11">
                          <div
                            className="gbh-full-w-menu"
                            style={{ transition: "all 2s ease 0s" }}
                          >
                            <div className="bg-dim">
                              <div className="gbh-full-w-menu__inner">
                                <div className="gbh-full-max-width">
                                  <div className="gbh-full-w-menu__left-cont">
                                    <div className="gbh-full-w-menu__left-cont__top">
                                      <div className="gbh-full-w-menu__left-cont__top__cont">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                              item.mainTitle
                                            ),
                                          }}
                                        />

                                        <div
                                          className="gbh-full-w-menu__left-cont__description"
                                          style={{
                                            transition: "none 0s ease 0s",
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                              item.description
                                            ),
                                          }}
                                        />
                                      </div>
                                      <ul className="nav flex-column gbh-full-w-menu__left-cont__menu-list">
                                        {item?.drawerItems?.map(
                                          (navItem, index) => {
                                            return (
                                              <li
                                                key={`navItem-${index}`}
                                                className="nav-item "
                                              >
                                                <a
                                                  className={`gbh-data-layer nav-link${
                                                    navItem?.subNavLinkRef
                                                      ? " extranal-sub-nav"
                                                      : ""
                                                  } `}
                                                  target={`${
                                                    navItem.newTab
                                                      ? "_blank"
                                                      : "_self"
                                                  }`}
                                                  href={removeAndCleanLinkConcat(
                                                    navItem?.subNavLink
                                                  )}
                                                  data-gbh-data-layer={`{"clickInternalLinks":"${
                                                    navItem?.subNavLinkRef
                                                      ? "false"
                                                      : "true"
                                                  }","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"${getAnalyticLinkUrl(
                                                    removeAndCleanLinkConcat(
                                                      navItem?.subNavLink
                                                    )
                                                  )}","internalLinkName":"${items[
                                                    "cq:panelTitle"
                                                  ]?.toLowerCase()} > ${navItem?.subNavName.toLowerCase()}","eventName":"main dropdown  menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}`}
                                                  rel={`${
                                                    navItem?.subNavLinkRef
                                                      ? "noreferrer"
                                                      : ""
                                                  }`}
                                                  data-hover="tab"
                                                  role="link"
                                                >
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        DOMPurify.sanitize(
                                                          navItem.subNavName
                                                        ),
                                                    }}
                                                  />
                                                  {navItem?.subNavLinkRef && (
                                                    <div className="sub-cat-img">
                                                      {item?.externalIconCheckbox && (
                                                        <img
                                                          src={
                                                            item?.externalIcon
                                                          }
                                                          alt="external link"
                                                          href={
                                                            navItem.subNavLink
                                                          }
                                                        />
                                                      )}
                                                    </div>
                                                  )}
                                                </a>
                                              </li>
                                            )
                                          }
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="gbh-full-w-menu__right-img">
                                    {item?.drawerImage?.imageUrl && (
                                      <img
                                        src={item?.drawerImage?.imageUrl}
                                        className="cmp-image__image"
                                        alt={item?.drawerImage?.imageAlt}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="productbg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            } else {
              return (
                <div
                  role="tabpanel"
                  tabIndex="-1"
                  className={`cmp-tabs__tabpanel`}
                >
                  <div className={`${staticClasses.CONTAINER}`}>
                    <div className="cmp-container">
                      <div className="aem-Grid aem-Grid--11 aem-Grid--default--11 ">
                        <div className="globalnavigation aem-GridColumn aem-GridColumn--default--12">
                          <div className={`gbh-product-menu`}>
                            <div className="gbh-pro-menu__inner">
                              <ul
                                className="flex-column gbh-pro-menu__list nav"
                                role="tablist"
                                aria-label="list of 6"
                                tabIndex="0"
                              >
                                <button className="gbh-mob-back-btn">
                                  Menu
                                </button>
                                {categoryItems &&
                                  categoryItems.map((item, index) => {
                                    return (
                                      <li
                                        key={`productNavigation-${index}`}
                                        className="nav-item"
                                        data-tab={item?.categoryName}
                                        role="tab"
                                      >
                                        <a
                                          onMouseOver={() =>
                                            onHoverMainCategory(
                                              !(
                                                !item?.categoryLinkRef &&
                                                item?.categoryLink
                                              )
                                                ? item?.categoryName
                                                : ""
                                            )
                                          }
                                          className={`gbh-data-layer nav-link `}
                                          aria-hidden="false"
                                          aria-label={item?.categoryName}
                                          data-gbh-data-layer={`{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"","internalLinkName":"products > ${item?.categoryName.toLowerCase()}","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}`}
                                          data-hover="tab"
                                          data-target={`#submenu${item?.categoryName
                                            .toLowerCase()
                                            .split(" ")
                                            .join("-")}`}
                                          aria-controls={`submenu${item?.categoryName
                                            .toLowerCase()
                                            .split(" ")
                                            .join("-")}`}
                                          rel="noreferrer"
                                          role="tab"
                                          tabIndex="0"
                                          href={
                                            !item?.categoryLinkRef &&
                                            item?.categoryLink
                                              ? removeAndCleanLinkConcat(
                                                  item?.categoryLink
                                                )
                                              : null
                                          }
                                          aria-selected={
                                            item?.categoryLinkRef ? "true" : ""
                                          }
                                          aria-expanded={
                                            item?.categoryLinkRef ? "true" : ""
                                          }
                                          dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                              item?.categoryName
                                            ),
                                          }}
                                        ></a>
                                      </li>
                                    )
                                  })}
                              </ul>
                              <div className="tab-content gbh-pro-menu__cont">
                                {categoryItems &&
                                  categoryItems.map((mainCategory, i) => {
                                    return (
                                      <div
                                        key={`mainCategory-${i}`}
                                        className={`tab-pane fade `}
                                        role="tabpanel"
                                        aria-labelledby={
                                          mainCategory?.categoryName
                                        }
                                      >
                                        <div className="cmp-container">
                                          <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                                            <div className="globalnavigation-subcategory aem-GridColumn aem-GridColumn--default--12">
                                              <ul className="nav gbh-pro-collection gbh-two-column">
                                                {mainCategory?.subCategoryDetails &&
                                                  mainCategory?.subCategoryDetails?.childItems?.map(
                                                    (subCategory, j) => {
                                                      return (
                                                        <li
                                                          key={`subCategory-${j}`}
                                                          className="nav-item gbh-pro-collection__category-link"
                                                          onMouseOver={() =>
                                                            onHoverSubCategory(
                                                              subCategory?.subCategory
                                                            )
                                                          }
                                                        >
                                                          <a
                                                            data-purelink="true"
                                                            href={removeAndCleanLinkConcat(
                                                              subCategory?.subLink
                                                            )}
                                                            className={
                                                              "gbh-data-layer nav-link"
                                                            }
                                                            id={`pills-${mainCategory?.categoryName
                                                              .split(" ")
                                                              .join(
                                                                "-"
                                                              )}-${subCategory?.subCategory
                                                              .split(" ")
                                                              .join("-")}-tab`}
                                                            aria-hidden="false"
                                                            aria-label={`tab ${j} of ${mainCategory?.subCategoryDetails?.childItems.length} Collections`}
                                                            data-hover="tab"
                                                            tabIndex="0"
                                                            target="_self"
                                                            data-target={`#${subCategory?.subCategory
                                                              .split(" ")
                                                              .join(
                                                                "-"
                                                              )}${mainCategory?.categoryName
                                                              .toLowerCase()
                                                              .split(" ")
                                                              .join("-")}`}
                                                            role="link"
                                                            aria-controls={`pills-${subCategory?.subCategory
                                                              .split(" ")
                                                              .join("-")}`}
                                                            data-gbh-data-layer={`{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"${removeAndCleanLinkConcat(
                                                              subCategory?.subLink
                                                            )}","internalLinkName":" ${selectedTab} > ${mainCategory?.categoryName
                                                              .toLowerCase()
                                                              .split(" ")
                                                              .join(
                                                                "-"
                                                              )} > ${subCategory?.subCategory
                                                              .split(" ")
                                                              .join(
                                                                "-"
                                                              )}","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}`}
                                                          >
                                                            <span className="nav-link">
                                                              <span
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    DOMPurify.sanitize(
                                                                      subCategory?.subCategory
                                                                    ),
                                                                }}
                                                              />
                                                            </span>
                                                          </a>
                                                        </li>
                                                      )
                                                    }
                                                  )}
                                              </ul>
                                              <div className="tab-content gbh-pro-collection-cont gbh-two-column">
                                                {mainCategory?.subCategoryDetails &&
                                                  mainCategory?.subCategoryDetails?.childItems?.map(
                                                    (subCategory, j) => {
                                                      return (
                                                        <div
                                                          key={`subcatInfo-${j}`}
                                                          className={`tab-pane fade gbh-mob-col `}
                                                        >
                                                          <a
                                                            href={removeAndCleanLinkConcat(
                                                              subCategory?.subLink
                                                            )}
                                                            className="gbh-data-layer"
                                                            data-gbh-data-layer={`{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"${removeAndCleanLinkConcat(
                                                              subCategory?.subLink
                                                            )}","internalLinkName":" > ${mainCategory?.categoryName
                                                              .toLowerCase()
                                                              .split(" ")
                                                              .join(
                                                                "-"
                                                              )} > ${subCategory?.subCategory
                                                              .split(" ")
                                                              .join(
                                                                "-"
                                                              )}","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}`}
                                                          ></a>
                                                        </div>
                                                      )
                                                    }
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                              </div>
                              <span
                                className="gbh-promenu-close-btn icon-Close-Large"
                                aria-label="close"
                                role="button"
                                tabIndex="0"
                              ></span>
                            </div>
                          </div>
                          <div className={`productbg`}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          })}
      </div>
    </div>
  )
}

export default HeaderNavTabsLoader
